module.exports = __webpack_public_path__ + "static/img/style_1.83cc6752.png";